// extracted by mini-css-extract-plugin
module.exports = {"CButton":"styles_CButton__L6zwB","noBorder":"styles_noBorder__3QaHw","whiteBackground":"styles_whiteBackground__2taRg"};